export const API_URL = "https://plesh-remote-multi-user-api-y2qbyk5t3a-ew.a.run.app/"
//export const API_URL = "http://localhost:8080/"
//export const TOOLPRESS_API = "https://api-tool-press-yn26wrnl4q-ey.a.run.app"
export const TOOLPRESS_API = "https://toolpress-api.2ndstage.app"

export const THEME_CONFIG = {
    mode:"dark",
    gradients: {
        default: ['#FF8400', '#FF8400'],
        home_question: ['#FF8400', '#FF8400'],
    },
    borders : {
        default: 'none',
        home_question: 'none'
    },
    borderRadius: {
        default: '2rem',
        photo: '1rem',
        textField: '1rem !important',
    },
    shadows : {
        default: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        home_question: '0px 4px 4px rgba(0, 0, 0, 0.25)'
    },

    agendaStyle : {
        headerColor: '#FF8400',
        boxShadow: '0px 8px 10px 0px rgba(0,0,0,0.2)',
        borderRadius: '0px',
        headerTextColor: '#fff',
        contentTextColor: '#fff',
        iconColor: '#fff',
        backgroundColor: '#2e1344',
    },

    agendaViewStyle : {
        todayHeaderBkgColor: '#FF8400',
        headerBkgColor: '#1c0b28',
        todayTitleColor: '#fff',
        titleColor: '#fff',
        timesColor: '#fff',
        textColor: '#fff',
        accordionBkgColor: '#2e1344'
    },

    primary: '#FF8400',
    secondary: '#263238',
    accent: '#FF8400',
    text: '#eceff1',
    buttonText: {
        home_question: '#fff',
        default: '#fff'
    },
    background:"linear-gradient(162.44deg, #FEF1DE 0%, #FFFFFF 30%, #FFFFFF 60%, #FEF1DE 100%)",

    homeQuestionIcon: false,

    poll: {
        default:"transparent",
        answered:"#FF8400",
        correct: '#3A722D',
        wrong: '#DB0A16'
    },
    pollBorder: {
        default:"#FF8400",
        answered:"#FF8400",
        correct: '#3A722D',
        wrong: '#DB0A16'
    },
    pollTextColor: {
        default:"#011A3D",
        answered:"#fff",
        correct: '#fff',
        wrong: '#fff'
    }
}